// Shared helper to open access-gated receipts/files.
// SEC-004 (iter 40): /api/files/{name} now requires either a Bearer header or a
// short-lived signed token (?t=...). For new-tab anchor clicks the browser
// doesn't send our JWT header, so we fetch a signed URL first and open that.
import api from "./api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * @param {string} receiptUrl  Relative URL like "/api/files/abc.pdf"
 * Returns: nothing — opens the signed URL in a new tab.
 */
export async function openReceipt(receiptUrl) {
  if (!receiptUrl) return;
  // Legacy/seed data may already be a fully-qualified URL (e.g. example.com placeholder).
  // Open those verbatim — they're not gated by our /api/files endpoint.
  if (/^https?:\/\//i.test(receiptUrl)) {
    window.open(receiptUrl, "_blank", "noopener,noreferrer");
    return;
  }
  // Extract filename from "/api/files/<name>"
  const match = receiptUrl.match(/\/api\/files\/([^?]+)/);
  if (!match) {
    // Fallback for legacy/unknown URL shapes — open as-is.
    window.open(`${BACKEND_URL}${receiptUrl}`, "_blank", "noopener,noreferrer");
    return;
  }
  const filename = match[1];
  try {
    const r = await api.post(`/files/${encodeURIComponent(filename)}/signed-url`);
    window.open(`${BACKEND_URL}${r.data.url}`, "_blank", "noopener,noreferrer");
  } catch (err) {
    // If signing fails (e.g. 404), fall back to unsigned (server will 401 cleanly).
    window.open(`${BACKEND_URL}${receiptUrl}`, "_blank", "noopener,noreferrer");
  }
}
